import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { MDBBtn } from 'mdbreact';
import { ObtenerListaMarcasTecdocEnAPI, ActualizarReglasMarcasGruposMontajeEnAPI, ObtenerGruposMontajeMarcasTecdocEnAPI } from "../../action/actionCreatorsRequests"
import 'antd/dist/antd.css';
import { Drawer, Row, Col, Checkbox } from 'antd';
import { MSGERROR, MSGOK, traducirPagina } from "../../librerias/funciones"
import {
    CloseOutlined,
    SearchOutlined,
    SaveOutlined
} from '@ant-design/icons';
import MantenimientoMarcas from '../MantenimientoMarcas.jsx';


const FichaMarcasVehiculo = ({ props, configApp }) => {
    const [hayMarcasVehiculo, setHayMarcasVehiculo] = React.useState(false);
    const [obtenerMarcasVehiculo, setObtenerMarcasVehiculo] = React.useState([]);
    const [obtenerMarcasVehiculoAux, setObtenerMarcasVehiculoAux] = React.useState([]);

    const [obtenerGrupos, setObtenerGrupos] = React.useState([]);
    const [obtenerGruposAux, setObtenerGruposAux] = React.useState([]);
    const [abriMantenimientoMarcas, setAbriMantenimientoMarcas] = React.useState(false);
    const [txtMarca, setTxtMarca] = React.useState("");
    const [marcaActual, setMarcaActual] = React.useState({});
    const [grupoSeleccionado, setGrupoSeleccionado] = React.useState([]);


    const modelarDatos = (marcas) => {
        let listaMarca = [];
        let objetoNuevoMarcas = [];
        let contAux = 0;

        for (var i = 0; i < marcas.length; i++) {
            contAux += 1;
            if (contAux <= 3) {
                listaMarca.push({ "Codigo": marcas[i].ID, "Marca": marcas[i].MARCA, "Imagen": "" })
                if ((marcas.length - 1) === i) {
                    objetoNuevoMarcas.push({ "lista": listaMarca });
                }
            } else {
                objetoNuevoMarcas.push({ "lista": listaMarca });
                contAux = 0;
                listaMarca = []
                i = (i - 1)
            }
        }
        return objetoNuevoMarcas.length === 0 ? null : objetoNuevoMarcas;
    }


    const modelarDatosGrupo = (marcas) => {
        let listaMarca = [];
        let objetoNuevoMarcas = [];
        let contAux = 0;

        for (var i = 0; i < marcas.length; i++) {
            contAux += 1;
            if (contAux <= 2) {
                listaMarca.push({ "ID": marcas[i].ID, "NOMBRE": marcas[i].NOMBRE, "Imagen": "" })
                if ((marcas.length - 1) === i) {
                    objetoNuevoMarcas.push({ "lista": listaMarca });
                }
            } else {
                objetoNuevoMarcas.push({ "lista": listaMarca });
                contAux = 0;
                listaMarca = []
                i = (i - 1)
            }
        }
        return objetoNuevoMarcas.length === 0 ? null : objetoNuevoMarcas;
    }



    const buscarEnTabla = (palabraABuscar) => {
        let palabra = palabraABuscar.target.value;
        if (palabra !== "") {
            if (obtenerMarcasVehiculoAux !== null) {
                let resultadoFiltro = obtenerMarcasVehiculoAux.filter((item) => {
                    return item.MARCA.toUpperCase().includes(palabra.toUpperCase()) ||
                        item.MARCA.toUpperCase() === palabra.toUpperCase()
                })
                if (resultadoFiltro.length > 0) {
                    setObtenerMarcasVehiculo(modelarDatos(resultadoFiltro));
                } else {
                    setObtenerMarcasVehiculo(null);
                }

            }
        } else {
            setObtenerMarcasVehiculo(modelarDatos(obtenerMarcasVehiculoAux));
        }
    }



    const buscarGruposMontaje = (ID_MARCA) => {
        setObtenerGrupos([]);
        setObtenerGruposAux([])

        ObtenerGruposMontajeMarcasTecdocEnAPI(ID_MARCA).then(marcas => {
            if (marcas.REGISTROS !== undefined && marcas.REGISTROS !== null && marcas.REGISTROS.length > 0) {
                setObtenerGrupos(modelarDatosGrupo(marcas.REGISTROS));
                setObtenerGruposAux(marcas.REGISTROS)
            } else {
                setObtenerMarcasVehiculo(null);
                setObtenerGrupos(null);

                setObtenerGruposAux([])
            }
        })
    }




    const grupoSeleccionadoActual = (registro, estaSeleccionnado) => {

        if (grupoSeleccionado.length === 0) {
            setGrupoSeleccionado([registro])
        } else {
            let existeGrupo = grupoSeleccionado.filter((ITEM) => ITEM.ID === registro.ID)
            if (existeGrupo.length === 0) {
                if (estaSeleccionnado) {
                    //añadir
                    // grupoSeleccionado = [...registro]
                    let recuperarDatos = [...grupoSeleccionado];
                    recuperarDatos.push(registro)
                    setGrupoSeleccionado([...recuperarDatos])
                } else {
                    //eliminnar
                    let nuevaLista = grupoSeleccionado.filter((eliminnar) => eliminnar.ID !== registro.ID)
                    setGrupoSeleccionado([...nuevaLista])

                }
            } else {
                //eliminnar
                let nuevaLista = grupoSeleccionado.filter((eliminnar) => eliminnar.ID !== registro.ID)
                setGrupoSeleccionado([...nuevaLista])
            }

        }
    }


    const gestionarRegla = (esAlta) => {
        if (Object.keys(marcaActual).length > 0) {
            if (grupoSeleccionado.length > 0) {
                if (esAlta) {
                    ActualizarReglasMarcasGruposMontajeEnAPI(0, null, props.ID_SOCIO, marcaActual.Codigo, marcaActual.Marca, grupoSeleccionado).then(estado => {
                        if (estado.OK) {
                            MSGOK(traducirPagina("Regla_creada"))
                            props.CERRAR_FICHA(false)

                            props.ACTUALIZAR_TABLA(1, "A", props.ID_SOCIO, "", "", "", "")

                        } else {
                            setObtenerMarcasVehiculo(null);
                        }
                    })
                } else {
                }
            } else {
                MSGERROR(traducirPagina("Seleccionar_grupo_varios"))
            }
        } else {
            MSGERROR(traducirPagina("Seleccionar_una_marca"))
        }
    }


    if (!hayMarcasVehiculo && props.ABRIR_FICHA) {
        setHayMarcasVehiculo(true)

        setAbriMantenimientoMarcas(true)

        ObtenerListaMarcasTecdocEnAPI(10000, 1, 1, "A", null).then(marcas => {
            if (marcas.REGISTROS !== undefined && marcas.REGISTROS !== null && marcas.REGISTROS.length > 0) {
                setObtenerMarcasVehiculoAux(marcas.REGISTROS);
                setObtenerMarcasVehiculo(modelarDatos(marcas.REGISTROS));


            } else {
                setObtenerMarcasVehiculo(null);
            }
        })


    } else {
        if (!props.ABRIR_FICHA && hayMarcasVehiculo) {
            setObtenerMarcasVehiculo([])
            setHayMarcasVehiculo(false)
            if (document.getElementById("buscadorMarcaVeh") !== null) {
                document.getElementById("buscadorMarcaVeh").value = "";
            }
        }
    }



    return (
        <div>
            <Drawer
                width={"50%"}
                onClose={() => { props.CERRAR_FICHA(false) }}
                visible={props.ABRIR_FICHA}
                placement={"right"}
                closable={false}
                bodyStyle={{ padding: '0px' }}
                style={{ zIndex: '999', color: '#fff' }}>



                <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                        <div> {props.title}</div>
                    </div>
                </div>



                <div className="p-3">
                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>
                        <Col md={24}>
                            <span>{traducirPagina("Msg_filtro_grupo")} </span>
                        </Col>

                        <Col md={24}>
                            <div className="mdb-skin">
                                <div style={{ fontSize: '16px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start' }}>
                                    <div style={{ width: '89%' }}>
                                        <input disabled={true} value={txtMarca} className="form-control" type="text" aria-label="Search" placeholder={traducirPagina("Seleccion_marca")} style={{ backgroundColor: "#f1f1f1", border: '0px', height: '100%', color: '#000', padding: '10px', borderRadius: '4px 0px 0px 4px' }} autoComplete="off" onChange={(e) => { buscarEnTabla(e); setTxtMarca(e.target.value) }} />
                                    </div>

                                    <div style={{ backgroundColor: '#f1f1f1', width: '5%' }}>
                                        <MDBBtn id="closeBuscadorMarcaVeh" onClick={e => {

                                            setTxtMarca("");
                                            setObtenerGrupos([]);
                                            setObtenerGruposAux([]);
                                            setMarcaActual({})

                                            setAbriMantenimientoMarcas(true)

                                        }} style={{ border: '0', padding: '10px', margin: '0', boxShadown: 'none', visibility: txtMarca !== "" ? 'visible' : 'hidden' }} className="btn-matriculav2">  <CloseOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>
                                    </div>
                                    <div style={{ backgroundColor: '#f1f1f1', width: '1%' }}>
                                        <div className="barraLateral" style={{ height: '33px' }} ></div>
                                    </div>
                                    <div style={{ backgroundColor: '#f1f1f1', width: '5%' }}>
                                        <MDBBtn onClick={e => { setAbriMantenimientoMarcas(true) }} style={{ border: '0', padding: '10px 10px 10px 10px', margin: '0', boxShadown: 'none' }} className="btn-matricula">  <SearchOutlined style={{ color: '#666', cursor: 'pointer', fontSize: '20px' }} />  </MDBBtn>

                                    </div>
                                </div>

                            </div>
                        </Col>

                        <Col md={24}>
                            <span>{traducirPagina("Msg_filtro_grupo_marca")} </span>
                        </Col>

                        <Col md={24}>
                            {
                                <div style={{ height: (configApp.height - 260).toString() + "px", overflowY: 'auto', overflowX: 'hidden' }}>
                                    {
                                        obtenerGrupos === null ?
                                            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                            :
                                            obtenerGrupos.length > 0 ?
                                                obtenerGrupos.map((item, i) =>
                                                    <div style={{ padding: '5px', fontSize: '14px', fontWeight: '500', display: 'flex', justifyContent: 'flex-start' }}>
                                                        {item.lista.map((row, i) =>
                                                            <div style={{ width: '50%' }}>
                                                                <Checkbox onChange={(e) => { grupoSeleccionadoActual(row, e.target.checked); console.log(e, row.NOMBRE) }}> {row.NOMBRE} </Checkbox>
                                                            </div>
                                                        )}
                                                    </div>
                                                )
                                                :
                                            Object.keys(marcaActual).length > 0 ?
                                                    obtenerGrupos === null ?
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh' }}> <h3>{traducirPagina("Sin_resultados")}</h3> </div>
                                                        :
                                                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '70vh', color: '#000' }}> <div color="mdb-color darken-3" className="spinner-border  fast" role="status" disabled /> </div>
                                                    :
                                                    null
                                    }
                                </div>
                            }
                        </Col>


                        <Col md={24}>

                            <div className="menu_mantenimiento" style={{ padding: '10px 0px' }}>
                                <div className="mantenimiento_item1"></div>
                                <div className="mantenimiento_item2">
                                    <div className="botonNuevo" style={{ backgroundColor: 'var(--azul-claro-serca)', color: '#fff' }} onClick={() => {
                                        gestionarRegla(true)
                                    }}>
                                        <SaveOutlined /> {traducirPagina("Guardar_salir")}
                                    </div>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </div>
            </Drawer>


            {
                abriMantenimientoMarcas ?
                    <MantenimientoMarcas
                        title={traducirPagina("Seleccion_la_marca").toUpperCase()}
                        ABRIR_FICHA={abriMantenimientoMarcas}
                        CERRAR_FICHA={setAbriMantenimientoMarcas}
                        MARCA_SELECCIONADA={setTxtMarca}
                        MARCA_ACTUAL={setMarcaActual}
                        ID_SOCIO={props.ID_SOCIO}
                        BUSCAR_GRUPO={buscarGruposMontaje}
                        HAY_HARACA_SELECCIONADA={txtMarca.trim() !== "" ? true : false}
                        CERRAR_FICHA_PADRE={props.CERRAR_FICHA}
                    >
                    </MantenimientoMarcas>
                    :
                    null
            }
        </div>

    )
}

FichaMarcasVehiculo.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ACTUALIZAR_TABLA: PropTypes.func

};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaMarcasVehiculo);